import React, { useCallback } from 'react';
import { Field } from 'redux-form';
import { FormControlLabel, RadioGroup, FormControl } from '@material-ui/core';
import { FINALIZE_BUY_FEE_METHODS } from '../../../../constants';
import { StyledRadio } from './StyledRadio';

const ClearableRadioGroup = ({ input, hasAch, hasFlooring, onUserInteraction }) => {
  const { value, onChange } = input;

  const handleChange = useCallback(
    (event, newValue) => {
      if (onUserInteraction) {
        onUserInteraction();
      }
      onChange(newValue);
    },
    [onChange, onUserInteraction]
  );

  return (
    <FormControl>
      <RadioGroup row value={value} onChange={handleChange}>
        {hasAch && (
          <FormControlLabel
            style={{ marginLeft: '-7px' }}
            control={<StyledRadio />}
            value={FINALIZE_BUY_FEE_METHODS.ACH}
            label="ACH"
            disabled={!hasAch}
          />
        )}
        {hasFlooring && (
          <FormControlLabel
            control={<StyledRadio />}
            value={FINALIZE_BUY_FEE_METHODS.FLOORING}
            label="Flooring"
            disabled={!hasFlooring}
          />
        )}
        <FormControlLabel control={<StyledRadio />} value={FINALIZE_BUY_FEE_METHODS.OTHER} label="Other" />
        <FormControlLabel control={<StyledRadio />} value={FINALIZE_BUY_FEE_METHODS.ON_ACCOUNT} label="On Account" />
      </RadioGroup>
    </FormControl>
  );
};

const FinalizePaymentMethodPicker = ({ hasAch, hasFlooring, onUserInteraction }) => {
  return (
    <Field
      name="finalize_payment_method"
      component={ClearableRadioGroup}
      hasAch={hasAch}
      hasFlooring={hasFlooring}
      onUserInteraction={onUserInteraction}
    />
  );
};

export default FinalizePaymentMethodPicker;
